import axiosService from './axios-service';

class DemoService {
    public createOnboardDemoData = async (): Promise<void> => {
        await axiosService.post(`/api/customers/demo/onboard-data`, {});
    };

    public resetDemoData = async (): Promise<void> => {
        await axiosService.delete(`/api/customers/demo/reset-onboarded-data`);
    };
}

const demoService = new DemoService();
export default demoService;